import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import Image from "next/image";
var ResponsiveImage = function(props) {
    return /*#__PURE__*/ _jsx(Image, _object_spread({
        layout: "fill",
        objectFit: "cover"
    }, props));
};
export { ResponsiveImage };
